import { useEffect } from 'react';

import { fetchUser } from '@/src/features/app/commands/fetchUser';

export function useInitialization() {
  useEffect(() => {
    void fetchUser();
  }, []);
}
